import React from "react";

const NewsCard = ({ image, title, date, id }) => {
  return (
    <div className="col-lg-4 col-md-6 mb-4 col-xs-12">
      <a href={`/news/${id}`} className="text-decoration-none">
        <div className="card h-100 border-0 shadow-sm">
          <img 
            src={image} 
            alt={title} 
            className="card-img-top" 
            style={{ height: '200px', objectFit: 'cover' }}
          />
          <div className="card-body d-flex flex-column p-1 pt-2 pl-2">
            <h5 className="card-title mb-3" style={{ fontSize: '1.1rem', fontWeight: '600', color: '#787878' }}>
              {title}
            </h5>
            <div className="">
              <small style={{ fontSize: '0.85rem', color: '#878b8e' }}>
                {date}
              </small>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default NewsCard;


// WEBPACK FOOTER //
// src/components/NewsComponents/NewsCard.js